// dossierEditHandlers — handlers d'édition Client / Logement de la fiche dossier.
// CC-DEV1-18 — extraits d'AdminBlock (devenu code mort depuis la refonte P1.1)
// pour en faire la SOURCE UNIQUE réutilisable (InfosTab + tout futur écran).
// Chaque handler fait son PATCH et renvoie { ok, error } — le composant garde
// la main sur le toast / le refresh (onUpdate).
import { API, getAuthHeaders } from "./helpers";

// PATCH /metier/clients/{id} — champs bénéficiaire éditables (mêmes champs
// qu'AdminBlock : nom/prénom/email/téléphone/occupation + contact secondaire).
// La whitelist backend (core/database.update_client.allowed_fields) couvre tous
// ces champs.
export async function patchClient(clientId, form, tenantId) {
  if (!clientId) return { ok: false, error: "Pas de client_id" };
  const headers = getAuthHeaders(tenantId, "application/json");
  const body = {
    civilite: form.civilite || null,
    nom: form.nom,
    prenom: form.prenom,
    email: form.email,
    telephone: form.telephone,
    statut_occupation: form.statut_occupation || null,
    contact_secondaire_nom: form.contact_secondaire_nom || null,
    contact_secondaire_prenom: form.contact_secondaire_prenom || null,
    contact_secondaire_telephone: form.contact_secondaire_telephone || null,
    contact_secondaire_relation: form.contact_secondaire_relation || null,
  };
  try {
    const res = await fetch(`${API}/api/metier/clients/${clientId}`, {
      method: "PATCH", headers, credentials: "include", body: JSON.stringify(body),
    });
    if (res.ok) return { ok: true };
    const err = await res.json().catch(() => ({}));
    return { ok: false, error: err.detail || "Erreur sauvegarde" };
  } catch {
    return { ok: false, error: "Erreur réseau" };
  }
}

// PATCH /metier/dossiers/{id} — logement : adresse_projet (rue / CP / ville) +
// workflow_data.tef.infos_logement.type_logement. Le workflow_data existant est
// fusionné de façon NON destructive (comme AdminBlock).
export async function patchLogement(dossier, form, tenantId) {
  const dossierId = dossier?.id;
  if (!dossierId) return { ok: false, error: "Pas de dossier_id" };
  const headers = getAuthHeaders(tenantId, "application/json");
  const payload = {
    adresse_projet: {
      rue: form.rue,
      code_postal: form.code_postal,
      ville: form.ville,
    },
    workflow_data: {
      ...dossier.workflow_data,
      tef: {
        ...(dossier.workflow_data?.tef || {}),
        infos_logement: {
          ...(dossier.workflow_data?.tef?.infos_logement || {}),
          type_logement: form.type_logement,
        },
      },
    },
  };
  try {
    const res = await fetch(`${API}/api/metier/dossiers/${dossierId}`, {
      method: "PATCH", headers, credentials: "include", body: JSON.stringify(payload),
    });
    if (res.ok) return { ok: true };
    const err = await res.json().catch(() => ({}));
    return { ok: false, error: err.detail || "Erreur sauvegarde" };
  } catch {
    return { ok: false, error: "Erreur réseau" };
  }
}
